import useYWR, { YWRKey } from "@/features/ui/hooks/use-ywr";
import useFetcher from "@/utils/use-fetcher";
import { LightOrderSheetSet } from "@/features/order-sheets/order-sheet.type";
import { calcUrl } from "@/features/ui/helpers/fetcher-helpers";

// 오더시트세트 단위 제출처 변경 — 세트 안 모든 오더시트(취소 제외)와 세트를 함께 바꾼다.
// 변경 불가 상태의 시트가 하나라도 있으면 서버가 전체를 거부한다(부분 적용 방지).
export interface UpdateOrderSheetSetToBeSubmittedRequest {
  toBeSubmitted: {
    id: number;
  } | null;
}

export interface UpdateOrderSheetSetToBeSubmittedResponse
  extends LightOrderSheetSet {}

export interface UpdateOrderSheetSetToBeSubmittedPathParameter {
  agencyId: number;
  orderSheetSetId: number;
}

export const updateOrderSheetSetToBeSubmittedTemplateUrl =
  "/agencies/:agencyId/order-sheet-sets/:orderSheetSetId/to-be-submitted";

export const updateOrderSheetSetToBeSubmittedKey: YWRKey<UpdateOrderSheetSetToBeSubmittedPathParameter> =
  {
    url: (parameter) => {
      return calcUrl(updateOrderSheetSetToBeSubmittedTemplateUrl, parameter);
    },
    method: "put",
  };

export default function useUpdateOrderSheetSetToBeSubmitted() {
  const fetcher = useFetcher<
    UpdateOrderSheetSetToBeSubmittedRequest,
    UpdateOrderSheetSetToBeSubmittedResponse
  >();

  return useYWR(updateOrderSheetSetToBeSubmittedKey, fetcher);
}
